import { useTranslations } from "next-intl";
import React from "react";

type Props = {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  clear?: () => void;
  showClear?: boolean;
  /** Optional explainer shown next to the title. */
  info?: React.ReactNode;
  /** Short readout of the current value, shown on the right. */
  summary?: React.ReactNode;
};

const FilterWrapper: React.FC<Props> = ({
  icon,
  title,
  children,
  clear,
  showClear,
  info,
  summary,
}) => {
  const t = useTranslations("search");
  return (
    <div className="google-anno-skip flex w-full min-w-0 flex-col gap-3">
      <div className="flex min-h-6 flex-row flex-wrap items-center justify-between gap-x-2 gap-y-1">
        <div className="flex min-w-0 flex-row items-center gap-2 text-foreground">
          <span className="flex-none text-muted-foreground [&>svg]:size-4">
            {icon}
          </span>
          <h4 className="truncate text-sm font-semibold">{title}</h4>
          {info}
        </div>

        <div className="flex flex-none items-center gap-2">
          {summary && (
            <span className="text-xs font-medium tabular-nums text-muted-foreground">
              {summary}
            </span>
          )}
          {clear && showClear && (
            <button
              type="button"
              onClick={clear}
              aria-label={`${t("clear")}: ${title}`}
              className="rounded-md px-1 text-xs font-semibold text-accent underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
            >
              {t("clear")}
            </button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default FilterWrapper;
